import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Section = ({ title, items, empty, testid }) => (
  <div className="rounded-2xl border border-white/10 p-5" data-testid={testid}>
    <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-3">
      {title} ({items.length})
    </p>
    {items.length === 0 ? (
      <p className="text-sm text-slate-600">{empty}</p>
    ) : (
      <ul className="space-y-1.5">
        {items.map((t) => (
          <li key={t.id} className="text-sm text-slate-300 flex justify-between gap-4">
            <span className="truncate">{t.name || `Day ${t.day_number} draft`}</span>
            <span className="text-slate-500 shrink-0">{t.client_name}</span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const AdminToday = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/portal/admin/today`, { withCredentials: true })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return <Loader2 className="h-5 w-5 animate-spin text-slate-500" />;

  return (
    <div data-testid="admin-today">
      <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-500 mb-6">{data.date}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Section title="Needs completion today" items={data.due_today} empty="Nothing due today." testid="today-due" />
        <Section title="Completed today" items={data.completed_today} empty="Nothing completed yet today." testid="today-completed" />
        <Section title="Overdue" items={data.overdue} empty="Nothing overdue." testid="today-overdue" />
        <Section title="Waiting on client" items={data.waiting_on_client} empty="Nothing waiting on clients." testid="today-waiting" />
        <Section title="AI drafts awaiting approval" items={data.pending_approvals} empty="No drafts pending." testid="today-pending" />
        <div className="rounded-2xl border border-white/10 p-5" data-testid="today-flagged">
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-3">Flagged for monthly report</p>
          <p className="font-display text-4xl font-bold text-white">{data.flagged_for_report}</p>
          <p className="text-xs text-slate-500 mt-1">verified activities this month</p>
        </div>
      </div>
    </div>
  );
};
